import React from 'react'
import { Table } from 'antd'
import VirtualList from 'rc-virtual-list'
import styles from './index.less'

const Row = ({ children }) => {
    return <div className={styles.row}>{children}</div>
}

const Cell = ({ children, style }) => {
    return (
        <div className={styles.cell} style={style}>
            {children}
        </div>
    )
}

export default ({ dataSource, columns, rowKey, rowSelection, onScroll }: any) => {
    const renderBody = (rawData, { ref }) => {
        const childrenRender = (item: any) => {
            return (
                <Row key={rowKey}>
                    {columns.map((column: any) => {
                        const child =
                            typeof column.render === 'function'
                                ? column.render(item[column.dataIndex], item)
                                : item[column.dataIndex]

                        const cellStyles = {
                            width: `${column.width}px`,
                            maxWidth: `${column.width}px`,
                            textAlign: column.align
                        }

                        return (
                            <Cell key={column.dataIndex} style={cellStyles}>
                                {child}
                            </Cell>
                        )
                    })}
                </Row>
            )
        }

        return (
            <VirtualList ref={ref} data={rawData} height={400} itemHeight={48} itemKey={rowKey} onScroll={onScroll}>
                {childrenRender}
            </VirtualList>
        )
    }

    return (
        <Table
            className={styles.container}
            bordered
            size="small"
            pagination={false}
            columns={columns}
            dataSource={dataSource}
            components={{ body: renderBody }}
            scroll={{ y: 300 }}
            rowSelection={rowSelection}
        />
    )
}
